import { render, staticRenderFns } from "./MerchantInfo.vue?vue&type=template&id=84c4e862&scoped=true"
import script from "./MerchantInfo.vue?vue&type=script&lang=js"
export * from "./MerchantInfo.vue?vue&type=script&lang=js"
import style0 from "./MerchantInfo.vue?vue&type=style&index=0&id=84c4e862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c4e862",
  null
  
)

export default component.exports